import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const sameHost = typeof window !== "undefined" && new URL(ENV_URL).hostname === window.location.hostname;
export const API = `${sameHost ? ENV_URL : window.location.origin}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const hm = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.length === 10 ? `${s}T00:00` : s);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

const dmy = (s) => { const d = new Date(s); return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`; };
const safe = (s) => String(s || "").replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, " ").trim();
export const quoteFileName = (q) => `Preventivo ${safe(q.client_name)} ${dmy(q.created_at)}.pdf`;
export const orderFileName = (o, ext = "pdf") => `Ordine Estetica e Benessere ${dmy(o.created_at)}.${ext}`;

export const fmtEuro = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
